module.exports = __webpack_public_path__ + "static/media/icon-history.944cd8f1.svg";